import "./TradesPrompt.css";

export const TradesPrompt = () => (
  <h4 className="mobius-ai-trade-question__prompt">
    Select the business that most closely{" "}
    <br className="mobius-ai-trade-question__prompt-break" />
    describes what you do
  </h4>
);
